import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import FeaturedSection from './components/FeaturedSection';
import CategorySection from './components/CategorySection';
import LatestSection from './components/LatestSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

export default function Home() {
  useEffect(() => {
    document.title = '麻花视频-麻花视频在线观看电视剧与麻花视频电影免费观看电视剧|高清全集不缓冲';
  }, []);

  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <FeaturedSection />
        <CategorySection />
        <LatestSection />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />

      {/* SEO 结构化数据 */}
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
        "@context": "https://schema.org",
        "@type": "WebPage",
        "name": "麻花视频 - 在线观看电视剧和电影",
        "description": "麻花视频提供海量电视剧免费在线观看，涵盖最新电视剧全集、高清电视剧不缓冲播放，电影免费看，无需会员即可享受流畅观影体验。",
        "url": "https://www.mahuavideo.com/",
        "isPartOf": {
          "@type": "WebSite",
          "name": "麻花视频",
          "url": "https://www.mahuavideo.com/"
        },
        "breadcrumb": {
          "@type": "BreadcrumbList",
          "itemListElement": [{
            "@type": "ListItem",
            "position": 1,
            "name": "首页",
            "item": "https://www.mahuavideo.com/"
          }]
        }
      }) }} />

      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": [
          {
            "@type": "Question",
            "name": "麻花视频需要注册会员才能观看吗？",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "不需要！麻花视频所有内容完全免费，无需注册、无需登录、无需会员，打开即可享受高清流畅的观影体验。"
            }
          },
          {
            "@type": "Question",
            "name": "麻花视频支持哪些设备观看？",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "麻花视频支持全平台观看，包括电脑、手机、平板以及智能电视。"
            }
          },
          {
            "@type": "Question",
            "name": "为什么麻花视频可以免费观看？",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "麻花视频通过与多家内容提供商合作，采用广告支持的商业模式，让用户免费享受海量正版影视内容。"
            }
          },
          {
            "@type": "Question",
            "name": "麻花视频的画质如何？有高清选项吗？",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "麻花视频提供从标清到超清多种画质选择，大部分内容支持1080P高清和4K超清画质。"
            }
          },
          {
            "@type": "Question",
            "name": "遇到播放卡顿怎么办？",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "建议检查网络连接、尝试切换较低画质、清除浏览器缓存或更换其他浏览器。"
            }
          }
        ]
      }) }} />
    </>
  );
}